import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { GroupTaskDto } from '../../dto/GroupTaskDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApiVersion } from '../../utils/utils';
import { getApi } from '../getApi';

export const apiAddGroupTask = async (dto: GroupTaskDto) => {
  const apiVersion = getApiVersion();
  const params: IApiParams = {
    url: `/group-task/addGroupTask${apiVersion}.php`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
